import React from 'react';
import MajorsList from '../../components/proStudent/MajorsList/MajorsList';
import { Container, PageContainer } from '../../styles/components/Layout';
import styled from 'styled-components';
import { PageHeader, PageTitle } from '../../styles/components';



const MajorsPageDescription = styled.p`
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.textSecondary};
  font-size: 1.1rem;
  max-width: 800px;
`;

const MajorsPage = () => {
  return (
    <PageContainer>
      <Container>
       <PageHeader>
        <PageTitle>Academic Majors</PageTitle>
       </PageHeader>
        <MajorsPageDescription>
          Explore various academic majors and their details to help you make informed decisions about your educational path.
        </MajorsPageDescription>
        <MajorsList />
      </Container>
    </PageContainer>
  );
};

export default MajorsPage;